export const names = {
  rating: 'product_rating',
  advantages: 'product_advantages',
  disadvantages: 'product_disadvantages',
  comment: 'product_comment'
}